import { RootAppState } from '../types';

export const getPopupVisibility = (state: RootAppState) => state.popup.isExpanded;

export const getAccessibilityExpanded = (state: RootAppState) =>
  state.popup.isAccessibilityExpanded;

export const getPopupSettings = (state: RootAppState) => state.popup.settings;
